import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchFeature } from "GeneralTabAction";
import { screenHeightLeftFromTop } from "Constants";
import Features from "FeaturesComponent";

class FeaturesPage extends Component {
  constructor(props) {
    super(props);
    this.featuresRef = React.createRef();
    this.myRef = React.createRef();
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.props.fetchFeature(this.props.session);
    this.myRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  submit() {
    this.featuresRef.current.submitFeaturesData();
  }

  render() {
    let { deviceSize } = this.props;
    return (
      <div
        className="featureWap scrollable-content panel-body"
        style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        ref={this.myRef}
      >
        <Features
          submitFeaturesDataHandler={this.props.submitFeaturesDataHandler}
          ref={this.featuresRef}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, { fetchFeature }, null, {
  forwardRef: true,
})(FeaturesPage);
